<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on: dialogOn, attrs: dialogAttrs }">
      <ActivatorButton
        v-if="buttonTitle"
        :parent-attrs="dialogAttrs"
        :parent-on="dialogOn"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
        @activate="onButtonActivate"
      />
    </template>

    <v-form ref="form">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="item_.name"
                  :rules="nameRules"
                  hint="Protocol name"
                  label="Name"
                  persistent-hint
                  @input="checkName"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="item_.comment"
                  hint="Comment on the selected conversion records"
                  label="Comment"
                  persistent-hint
                />
              </v-col>
            </v-row>
            <v-row
              v-if="message"
              style="color: red; font-size: larger"
            >
              {{ message }}
            </v-row>
          </v-container>
          <v-progress-linear
            v-if="uploading"
            indeterminate
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="dialog = false"
            aria-label="Close"
          >
            Close
          </v-btn>
          <v-btn
            @click="onOk"
            aria-label="Save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { getErrorMessage } from '@/main'
import { defaultVTooltipProps } from '@/utils/defaultProps'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase],

  props: {
    item: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    item_: {
      name: null,
      comment: null,
    },
    uploading: false,
    rules: {
      required: (value) => !!value || 'Required',
      min: (v) => v != null && (v.length >= 6 || 'Min 6 characters'),
    },
    checks: {},
    defaultVTooltipProps,
  }),

  computed: {
    editMode() {
      return !!this.item && !!this.item.id
    },
    nameRules() {
      return [this.rules.required, this.rules.min, this.nameCheck]
    },
    nameCheck() {
      return (this.editMode && this.item_.name === this.item.name) || !this.checks.name || this.checks.name
    },
  },

  watch: {
    dialog(val) {
      if (val) Object.assign(this.item_, this.item)
    },
  },

  methods: {
    checkName() {
      this.$axios.get(`${this.apiUrl}/check?name=${encodeURIComponent(this.item_.name)}`).then((response) => {
        this.checks = response.data
      })
    },
    onOk() {
      if (this.$refs.form.validate()) {
        const item = Object.assign(this.item_, this.options)
        this.message = null
        this.uploading = true
        if (this.editMode) {
          this.$axios
            .put(`${this.apiUrl}/${this.item_.id}`, item)
            .then((response) => {
              this.uploading = false
              this.$emit('itemUpdated', response.data)
              this.dialog = false
            })
            .catch((error) => {
              this.uploading = false
              this.message = getErrorMessage(error)
            })
        } else {
          this.$axios
            .post(`${this.apiUrl}`, item)
            .then((response) => {
              this.uploading = false
              this.$emit('itemCreated', response.data)
              this.dialog = false
            })
            .catch((error) => {
              this.uploading = false
              this.message = getErrorMessage(error)
            })
        }
      }
    },
  },

  mounted() {
    Object.assign(this.item_, this.item)
  },
}
</script>
